/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Faq_2_AInputs */

const en_nfp_faq_2_a = /** @type {(inputs: Nfp_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once your charity registration is verified by our team, every PDF receipt generated by the system automatically includes your legal organization name and tax ID for your donors' records.`)
};

const es_nfp_faq_2_a = /** @type {(inputs: Nfp_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una vez que nuestro equipo verifique el registro de tu fundación, cada recibo PDF generado incluirá automáticamente tu nombre legal y número de registro fiscal.`)
};

const fr_nfp_faq_2_a = /** @type {(inputs: Nfp_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une fois l'enregistrement de votre association vérifié par notre équipe, chaque reçu PDF généré par le système inclut automatiquement le nom légal de votre organisation et votre numéro d'identification fiscale pour les dossiers de vos donateurs.`)
};

const de_nfp_faq_2_a = /** @type {(inputs: Nfp_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobald die Registrierung deiner Organisation verifiziert ist, enthält jede generierte PDF-Quittung automatisch den Namen und die Steuernummer deiner Organisation.`)
};

const id_nfp_faq_2_a = /** @type {(inputs: Nfp_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setelah pendaftaran amal Anda diverifikasi oleh tim kami, setiap tanda terima PDF yang dibuat oleh sistem secara otomatis menyertakan nama resmi organisasi dan ID pajak Anda untuk catatan donatur Anda.`)
};

/** @type {(inputs: Nfp_Faq_2_AInputs) => LocalizedString} */
const ja_nfp_faq_2_a = en_nfp_faq_2_a;

/** @type {(inputs: Nfp_Faq_2_AInputs) => LocalizedString} */
const zh_nfp_faq_2_a = en_nfp_faq_2_a;

/** @type {(inputs: Nfp_Faq_2_AInputs) => LocalizedString} */
const ar_nfp_faq_2_a = en_nfp_faq_2_a;

/** @type {(inputs: Nfp_Faq_2_AInputs) => LocalizedString} */
const it_nfp_faq_2_a = en_nfp_faq_2_a;

/** @type {(inputs: Nfp_Faq_2_AInputs) => LocalizedString} */
const ru_nfp_faq_2_a = en_nfp_faq_2_a;

/** @type {(inputs: Nfp_Faq_2_AInputs) => LocalizedString} */
const pt_nfp_faq_2_a = en_nfp_faq_2_a;

/** @type {(inputs: Nfp_Faq_2_AInputs) => LocalizedString} */
const ko_nfp_faq_2_a = en_nfp_faq_2_a;

/**
* | output |
* | --- |
* | "Once your charity registration is verified by our team, every PDF receipt generated by the system automatically includes your legal organization name and tax..." |
*
* @param {Nfp_Faq_2_AInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_faq_2_a = /** @type {((inputs?: Nfp_Faq_2_AInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Faq_2_AInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_faq_2_a(inputs)
	if (locale === "es") return es_nfp_faq_2_a(inputs)
	if (locale === "fr") return fr_nfp_faq_2_a(inputs)
	if (locale === "de") return de_nfp_faq_2_a(inputs)
	if (locale === "ja") return ja_nfp_faq_2_a(inputs)
	if (locale === "zh") return zh_nfp_faq_2_a(inputs)
	if (locale === "ar") return ar_nfp_faq_2_a(inputs)
	if (locale === "id") return id_nfp_faq_2_a(inputs)
	if (locale === "it") return it_nfp_faq_2_a(inputs)
	if (locale === "ru") return ru_nfp_faq_2_a(inputs)
	if (locale === "pt") return pt_nfp_faq_2_a(inputs)
	return ko_nfp_faq_2_a(inputs)
});